module.exports = __webpack_public_path__ + "img/21.02f6837a.png";